module.exports = __webpack_public_path__ + "sz.ec6e04001ff9ff105ead.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/sz.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/sz.svg
// module chunks = styles